import React from 'react'

import { Text, theme } from '@hhgtech/hhg-components'

import {
  StyledStepCardInfo,
  StyledStepCardTitle,
  StyledStepCardIcon,
  StyledStepCardDescription,
} from './index.styled'

type StepsProps = {
  steps: MechanismStep
}

const GamingMechanismStepCard = (mechanismSteps: StepsProps) => {
  return (
    <StyledStepCardInfo>
      <StyledStepCardTitle>
        <Text
          size="lg"
          type="bold"
          color={theme.colors.primary700}
          className="text"
        >
          {mechanismSteps.steps.title}
        </Text>
      </StyledStepCardTitle>
      <StyledStepCardIcon>
        <img loading="lazy" src={mechanismSteps.steps.icon} alt="" />
      </StyledStepCardIcon>
      <StyledStepCardDescription
        dangerouslySetInnerHTML={{
          __html: mechanismSteps.steps.description || '',
        }}
      />
    </StyledStepCardInfo>
  )
}

export { GamingMechanismStepCard }
